<template>
    <li>
        <div class="title"><span>セールス募集</span></div>
        <div class="detail">
            <p class="list_slash-separate"><span>ショップ</span><span>フランチャイズ</span><span>販売代行</span><span>その他</span></p>
            <p class="list_slash-separate"><span>営業代行</span><span>ショールーム</span><span>その他</span></p>
        </div>
    </li>
</template>